export const MARKETING_REPORT_SECTIONS = [
  {
    key: 'existing_customer_count',
    tabLabel: 'Existing Customers',
    title: 'Existing Customer only (Count)',
    description: 'Count of customers created before the selected report period.',
    type: 'count',
  },
  {
    key: 'new_customer_list',
    tabLabel: 'New Customer',
    title: 'New Customer',
    description: 'Customers created during the selected period with site and contact details.',
    columns: [
      { key: 'marketing_name', label: 'Marketing' },
      { key: 'customer_name', label: 'Customer' },
      { key: 'site_name', label: 'Site' },
      { key: 'site_address', label: 'Address' },
      { key: 'contact_person', label: 'Contact Person' },
      { key: 'contact_no', label: 'Contact No' },
      { key: 'email', label: 'Email' },
      { key: 'created_date', label: 'Created Date', align: 'center' },
    ],
  },
  {
    key: 'quotation_list',
    tabLabel: 'Quotations',
    title: 'Quotations',
    description: 'Quotations raised during the selected period.',
    columns: [
      { key: 'marketing_name', label: 'Marketing' },
      { key: 'quotation_no', label: 'Quotation No' },
      { key: 'quotation_date', label: 'Date', align: 'center' },
      { key: 'customer_name', label: 'Customer' },
      { key: 'site_name', label: 'Site' },
      { key: 'amount', label: 'Amount', align: 'end' },
    ],
    totalKeys: ['amount'],
  },
  {
    key: 'sales_order_list',
    tabLabel: 'Sales Order',
    title: 'Sales Order',
    description: 'Sales orders placed during the selected period.',
    columns: [
      { key: 'marketing_name', label: 'Marketing' },
      { key: 'order_no', label: 'SO No' },
      { key: 'order_date', label: 'Date', align: 'center' },
      { key: 'customer_name', label: 'Customer' },
      { key: 'site_name', label: 'Site' },
      { key: 'grade', label: 'Grade' },
      { key: 'quantity', label: 'Qty', align: 'end' },
      { key: 'amount', label: 'Amount', align: 'end' },
      { key: 'delivery_mode', label: 'Delivery' },
    ],
    totalKeys: ['quantity', 'amount'],
  },
  {
    key: 'sales_list',
    tabLabel: 'Sales',
    title: 'Sales',
    description: 'Sales invoices generated during the selected period.',
    columns: [
      { key: 'marketing_name', label: 'Marketing' },
      { key: 'invoice_no', label: 'Invoice No' },
      { key: 'invoice_date', label: 'Date', align: 'center' },
      { key: 'customer_name', label: 'Customer' },
      { key: 'site_name', label: 'Site' },
      { key: 'grade', label: 'Grade' },
      { key: 'quantity', label: 'Qty', align: 'end' },
      { key: 'amount', label: 'Amount', align: 'end' },
    ],
    totalKeys: ['quantity', 'amount'],
  },
  {
    key: 'payment_receipt_list',
    tabLabel: 'Payment Receipts',
    title: 'Payment Receipts',
    description: 'Payment receipts received during the selected period.',
    columns: [
      { key: 'marketing_name', label: 'Marketing' },
      { key: 'receipt_no', label: 'Receipt No' },
      { key: 'receipt_date', label: 'Date', align: 'center' },
      { key: 'customer_name', label: 'Customer' },
      { key: 'receipt_mode', label: 'Mode' },
      { key: 'instrument_no', label: 'Instrument No' },
      { key: 'amount', label: 'Amount', align: 'end' },
    ],
    totalKeys: ['amount'],
  },
  {
    key: 'outstanding_list',
    tabLabel: 'Outstanding',
    title: 'Outstanding',
    description: 'Outstanding invoices and opening balances as on the selected date.',
    columns: [
      { key: 'marketing_name', label: 'Marketing' },
      { key: 'document_type', label: 'Type' },
      { key: 'document_no', label: 'Document No' },
      { key: 'document_date', label: 'Date', align: 'center' },
      { key: 'customer_name', label: 'Customer' },
      { key: 'site_name', label: 'Site' },
      { key: 'grade', label: 'Grade' },
      { key: 'quantity', label: 'Qty', align: 'end' },
      { key: 'invoice_amount', label: 'Invoice Amount', align: 'end' },
      { key: 'outstanding_amount', label: 'Outstanding', align: 'end' },
    ],
    totalKeys: ['quantity', 'invoice_amount', 'outstanding_amount'],
  },
];

export function formatMarketingReportCell(value, key) {
  if (value === null || value === undefined || value === '') {
    return ['amount', 'quantity', 'invoice_amount', 'outstanding_amount'].includes(key) ? '-' : '';
  }
  if (['amount', 'quantity', 'invoice_amount', 'outstanding_amount'].includes(key)) {
    const numericValue = Number(value);
    return Number.isFinite(numericValue) ? numericValue.toFixed(2) : value;
  }
  return value;
}

export function filterMarketingReportRows(rows, columns, searchText) {
  const query = (searchText || '').trim().toLowerCase();
  if (!query || !rows?.length) {
    return rows || [];
  }
  return rows.filter((row) => columns.some((column) => {
    const value = row[column.key];
    return value !== null && value !== undefined && String(value).toLowerCase().includes(query);
  }));
}

export function getMarketingSectionCount(section, reportDetails) {
  if (section.type === 'count') {
    return Number(reportDetails.existing_customer_count || 0);
  }
  return (reportDetails[section.key] || []).length;
}

export const EMPTY_REPORT_DETAILS = {
  existing_customer_count: 0,
  new_customer_list: [],
  quotation_list: [],
  sales_order_list: [],
  sales_list: [],
  payment_receipt_list: [],
  outstanding_list: [],
};
